'use strict';

// detictzr adds a test named "highresolution", conditionally, for only tablet and mobile
// since desktops can now be hi res, we add the test for all the things.
// Doing this here instead of modifying Detectizr

define('lib/modernizr.retina',['modernizr'], function (modernizr) {
  modernizr.addTest('retina', function devicePixels() {
    return window.devicePixelRatio >= 2;
  });
});

